module.exports = __webpack_public_path__ + "assets/img/budapark5-320.f22db0b8.webp";